import React from 'react';

const ProfessionalExperience = () => {
    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Professional Experience</h3>
            </div>
            <div className="timeline">
                {/* Single event */}
                <div className="timeline-event te-primary">
                    <h5 className="event-date">Jun 2021 - Present</h5>
                    <h4 className="event-name">Programmer Analyst II</h4>
                    <span className="event-description">University of Southern California, San Diego, CA, USA</span>
                    <div>
                        <ul>
                            <li>
                                <p>
                                    Developed CloudFormation Scripts that streamlined the process of creating development and production environment in AWS.<br></br>
                                    Technologies: <i>AWS (VPC, S3, IAM - security groups, RDS, Elastic Beanstalk, EC2, Codepipeline, secrets manager, and systems manager)</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Redesigned the APTwebstudy website and separated the public face of the website from the private one by collaborating with the vendor.<br></br>
                                    Technologies: <i>HTML, CSS, Django Template, allauth, Django Rest Framework, and i18next</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Integrated Google Recaptcha in the Registration form to prevent bot attacks.<br></br>
                                    Technologies: <i>Django, allAuth, Google Recaptcha</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Migrated participant recruitments (APT Webstudy) web application from angularJS to React to improve rendering performance and maintainability of the application.<br></br>
                                    Technologies: <i>AngularJS, React (Axios, React Context, React Forms, React Router, react-i18next), PdfViewer</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Collaborated with the data managers to develop an API for the automation of 40,000 study participants' data migration from one clinic visit to another.<br></br>
                                    Technologies: <i>Python, Django Rest Framework, Amazon Cloudwatch, PostgreSQL</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Masked Protected Health information of study participants who declined the consent.
                                    <br></br>
                                    Technologies: <i>React (Apollo Client), and Django (Graphene)</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Implemented workflow that allows clinical monitors to refer study participants.<br></br>
                                    Technologies: <i>React (Apollo Client), Django (graphene), and allauth</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Increased the usability of existing clinical trials reports code base by identifying and architecting reusable components.<br></br>
                                    Technologies: <i>React</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Improved the performance of logs transactions query on 280K records from 48 seconds to 5 seconds.
                                    <br></br>
                                    Technologies: <i>React and Django</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Made visual analysis of clinical trials reports data possible by applying data visualizations and summarization techniques.
                                    <br></br>
                                    Technologies: <i>PostgreSQL</i>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* Single event */}
                <div className="timeline-event te-primary">
                    <h5 className="event-date">Aug 2019 - Sep 2021</h5>
                    <h4 className="event-name">Graduate Research Assistant</h4>
                    <span className="event-description">University of Iowa, Iowa City, IA, USA</span>
                    <div>
                        <ul>
                            <li>
                                <p>
                                    Engineered Pain Care Enhancement application that utilizes pain relief techniques to educate and assist Family Caregivers in chronic pain treatment.
                                    <br></br>
                                    Technologies: <i>JavaScript, JQuery, PHP, PostgreSQL</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Designed and developed an infrastructure to make distribution and decentralized computation of sensor/radar data possible.
                                    <br></br>
                                    Technologies: <i>WebRTC, Node.js, and Socket.IO</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Analyzed and increased the usability of the water quality dataset (10 M records approx.) by 66.67% by applying data preprocessing and wrangling techniques.
                                    <br></br>
                                    Technologies: <i>Microsoft Excel and MSSQL</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Developed an application for exploratory data analysis to speed up the analytical process of the environmental dataset for Researchers.
                                    <br></br>
                                    Technologies: <i>JavaScript, PHP, and PostgreSQL</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Increased the productivity of researchers by automating the data migration process from Iowa DNR.
                                    <br></br>
                                    Technologies: <i>Python</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Improved the analytic framework to study the water system network of Iowa by developing a web-based geographic information system.
                                    <br></br>
                                    Technologies: <i>Progressive Web Application, JavaScript, Google Maps</i>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* Single event */}
                <div className="timeline-event te-primary">
                    <h5 className="event-date">Jan 2019 - Aug 2019</h5>
                    <h4 className="event-name">Software Engineer</h4>
                    <span className="event-description">Folio3 PVT LTD, Lahore, PK</span>
                    <div>
                        <ul>
                            <li>
                                <p>
                                    Reduced the approval rate of fraudulent loan applications by developing a fraud detection system and incorporating a log analytics mechanism in the system.
                                    <br></br>
                                    Technologies: <i>Python, React, AWS Lambda, Amazon DynamoDB, and Sumo Logic</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Documented REST API specifications.
                                    <br></br>
                                    Technologies: <i>Swagger</i>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* Single event */}
                <div className="timeline-event te-primary">
                    <h5 className="event-date">Jun 2017 - Jan 2019</h5>
                    <h4 className="event-name">Software Engineer</h4>
                    <span className="event-description">Pentaloop PVT LTD, Lahore, PK</span>
                    <div>
                        <ul>
                            <li>
                                <p>
                                    Developed Web-Services (SOAP), Web-APIs (REST), and front-end application for a digital banking product.
                                    <br></br>
                                    Technologies: <i>Java, Spring, Angular 1, and Oracle</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Integrated P2P authentication mechanism using Java and Spring Security for secure communication with external components of the digital banking product.
                                    <br></br>
                                    Technologies: <i>Spring Security</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Automated the process of purging and archiving data from the production database (50 M records approx.) by developing a scheduler service.
                                    <br></br>
                                    Technologies: <i>Java, Spring, and Oracle-SQL</i>
                                </p>
                            </li>
                            <li>
                                <p>
                                    Designed and implemented a common core solution for incorporating SEPA transactions.
                                    <br></br>
                                    Technologies: <i>Java, Spring</i>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ProfessionalExperience;